<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">

						<!-- 选择章节 -->
						<el-form-item :label="isTitle ? '标题' : '科目'" prop="title">
							<el-input v-show="!isTitle" placeholder="请选择" disabled
								v-model="formParameter.title">
								<template slot="append">
									<el-button type="primary" @click="selectSub()">选择</el-button>
								</template>
							</el-input>
							<el-input v-show="isTitle" v-model="formParameter.title"
								autocomplete="off"></el-input>
						</el-form-item>

					</el-col>

					<el-col :span="24">
						<el-form-item label="总结名称" prop="name">
							<el-select v-if="formParameter.title == '职业素养与情商'" v-model="formParameterName"
								@change="loadContext" placeholder="请选择">
								<el-option
									v-for="i in ['【面试总结】', '【面试准备知识树】', '【个人技能】', '【岗位职责】', '【简历账号】']"
									:key="i" :label="i" :value="i">
								</el-option>
							</el-select>
							<el-input v-else v-model="formParameterName"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<el-row v-if="!formParameterName || '【个人技能】【岗位职责】【简历账号】'.indexOf(formParameterName) == -1">
					<el-col :span="24">
						<el-form-item label="学习时间" prop="subtime">
							<el-date-picker v-model="formParameter.subtime" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" align="right" type="date" placeholder="选择日期"
								:picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="总结内容" prop="content">
							<wang-edit v-model="formParameter.content"
								:isupdt="wangEditisupdt"></wang-edit>
						</el-form-item>
					</el-col>
				</el-row>
				<el-dialog :title="'请选择绑定【' + course + '】下的科目'" :visible.sync="dialogVisible" width="60%"
					:append-to-body="true">
					<tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList"
						:data="permissionList" :defaultParent="0" @nodeClick="treeClick"
						:expand-on-click-node="true">
					</tree>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="comfirmSub">确 定</el-button>
					</span>
				</el-dialog>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确
				定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>

import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/study/feedback/feedback.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import subApi from "@/api/edu/subject/subject.js";
import tree from "@/components/tree/tree.vue";

export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
		wangEdit,
		tree
	},
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						picker.$emit('pick', new Date());
					}
				}, {
					text: '昨天',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24);
						picker.$emit('pick', date);
					}
				}, {
					text: '一周前',
					onClick(picker) {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', date);
					}
				}]
			},
			colors: { 3: '#99A9BF', 5: '#FF9900' },
			disabled: false,
			popupLoading: false,

			wangEditisupdt: false,

			permissionList: [],
			dialogVisible: false,
			subData: [],

			confirmLoading: false,
			parameter: {},
			formParameter: {},
			formParameterName: '',
			isTitle: false,
			course: "",

			rules: {
				//标题
				title: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					}
				],

			}

		};
	},
	methods: {
		loadContext() {
			// console.log(" loadContext ")
			// 加载【个人技能】【岗位职责】【简历账号】
			if ('【个人技能】【岗位职责】【简历账号】'.indexOf(this.formParameterName) > -1) {
				let usr = this.$caches.user.get();
				console.log(usr)
				api.oneFeedback({ stuid: usr.id, type: this.formParameterName },
					res => {
						this.wangEditisupdt = true
						this.formParameter = res.data;
						setTimeout(() => {
							this.wangEditisupdt = false
						}, 100)
					}, err => {
						this.$utils.msg.warning(response.msg);

					}
				);

			}
		},

		treeClick(data) {
			this.subData = data;
		},
		selectSub() {

			if (this.permissionList == [] || this.permissionList.length == 0) {
				subApi.list({}, (response) => {
					this.permissionList = response.data;
				});
			}
			this.dialogVisible = true;

		},
		comfirmSub() {
			this.sbname = this.subData.name;
			this.formParameter.title = this.subData.name;
			this.dialogVisible = false;
			this.formParameterName = '';
		},



		//打开弹框
		open(parameter, title, disabled, size) {
			this.wangEditisupdt = true
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			setTimeout(() => {
				this.wangEditisupdt = false
			}, 100)
			this.course = this.$caches.myCourse.get();
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				//添加
				let parameter = this.$utils.merger(this.formParameter);
				parameter.name = this.formParameterName
				if ("x【个人技能】【岗位需求】【面试知识树】【招聘平台账号】【面试准备ALL】".indexOf(this.formParameterName) > 0) {
					parameter.title = parameter.name
				}
				api.save(parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.confirmLoading = false;
						this.$parent.list();
						this.close();
					},
					response => {
						this.$utils.msg.warning(response.msg);
						this.confirmLoading = false;
					}
				);

			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();

			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					this.formParameter = response.data;
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

/deep/.w-e-text-container {
	height: 450px !important;
	/*!important是重点，因为原div是行内样式设置的高度300px*/
}
</style>
